/* eslint-disable @typescript-eslint/no-unused-vars */
// |-- Built-in Dependencies --|
import React, { useState, useEffect } from "react"; //  { useState, useEffect } // ,
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import ConfigurationLayout from '../configuration/ConfigurationLayout'

// |-- External Dependencies --|

// |-- Internal Dependencies --|
import UserAcess from "../Layout/UserAccess";
import { useDispatch, useSelector } from "react-redux";
import {
  useAddUserAccessMutation,
  useGetUserAccessQuery,
  useIsUserExistsQuery,
  useUpdateUserAccessByUserIdMutation,
  useUpdateUserAccessMutation,
} from "src/services/useraccess/UserAccessServices";
import { RootState } from "src/redux/store";
import { showToast } from "src/utils/showToaster";
import { setCheckUserAccess } from "src/redux/slices/access/userAcessSlice";

const EditUserAccessWrapper = () => {
  const [apiStatus, setApiStatus] = useState(false);
  const [userRoleState, setUserRoleState] = React.useState<string>();
  const { roleId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [buttonValue, setButtonValue] = useState("save");
  const [isUserExists, setIsUserIxists] = useState(false);
  const [addUserAccess] = useAddUserAccessMutation();
  const [updateUserAccess] = useUpdateUserAccessMutation();
  const [updateByUserId] = useUpdateUserAccessByUserIdMutation();
  const { userData } = useSelector((state: RootState) => state?.auth);

  const userId = userData?.userId;

  const { data, isLoading, isFetching } = useGetUserAccessQuery(
    {
      userId: null,
      userRoleName: roleId as string,
    },
    {
      skip: !roleId,
    }
  );

  // iue => if user exists
  const {
    data: iueData,
    isLoading: iueIsLoading,
    isFetching: iueIsFetching,
  } = useIsUserExistsQuery(userData?.userId, { skip: !userData?.userId });
  const { checkUserAccess } = useSelector(
    (state: RootState) => state.userAccess
  );

  useEffect(() => {
    if (iueData?.data) {
      setIsUserIxists(iueData?.data);
    }
  }, [iueData, iueIsLoading, iueIsFetching]);

  useEffect(() => {
    if (roleId) {
      setUserRoleState(roleId);
    }
  }, [roleId]);

  const handleUserAccessSubmit = () => {
    setApiStatus(true);
    setTimeout(() => {
      // if ((userId && isUserExists === false) || buttonValue === "save") {
      //   addUserAccess({
      //     userId: userId ? userId : null,
      //     userRoleId: "",
      //     userRoleName: "",
      //     departmentId: "",
      //     departmentName: "",
      //     module: [...checkUserAccess.modules],
      //   }).then((res) => {
      //     if ("data" in res) {
      //       if (res?.data?.status) {
      //         setButtonValue("update");
      //         showToast("success", "User Access successfully!");
      //         navigate(`/configurations/user-access`, {
      //           state: {
      //             dept: "",
      //             userRole: "",
      //             userId: userId,
      //           },
      //         });
      //       } else {
      //         showToast("error", res?.data?.message);
      //       }
      //     } else {
      //       showToast("error", "Something went wrong");
      //     }
      //     setApiStatus(false);
      //   });
      // }
      //  else
      let modules = checkUserAccess.modules.map((module) => {
        let { _id, moduleAction, ...rest }: any = module;
        let action = moduleAction?.map((action: any) => {
          let { _id, fields, ...rest }: any = action;
          let field = fields?.map((action: any) => {
            let { _id, ...rest }: any = action;
            return { ...rest}
          });
          return { ...rest, fields: [...field] };
        });
        return { ...rest, moduleAction:[...action] };
      });

      // let mouduls = [...checkUserAccess.modules];
      if (userId && isUserExists === true) {
        updateByUserId({
          body: {
            userId: userId,
            // departmentId: "",
            // departmentName: "",
            userRoleId: roleId,
            userRoleName: "" || "",
            module: [...modules],
          },
          id: userId,
        }).then((res:any) => {
          if ("data" in res) {
            if (res?.data?.status) {
              showToast("success", "User Access updated successfully!");
              navigate(`/configurations/user-access`, {
                state: {
                  dept: "",
                  userRole: "",
                  userId: userId,
                },
              });
            } else {
              showToast("error", res?.data?.message);
            }
          } else {
            showToast("error", "Something went wrong");
          }
          setApiStatus(false);
        });
      } else {
        updateUserAccess({
          body: {
            // userId:"",
            userRoleName: roleId,
            module: [...modules],
          },
          userRole: roleId as string,
        }).then((res:any) => {
          if ("data" in res) {
            if (res?.data?.status) {
              showToast("success", "User Access updated successfully!");
              navigate(`/admin/user-role`);
            } else {
              showToast("error", res?.data?.message);
            }
          } else {
            showToast("error", "Something went wrong");
          }
          setApiStatus(false);
        });
      }
    }, 1000);
  };

  useEffect(() => {
    if (!isLoading && !isFetching && data) {
      if (data?.data) {
        setButtonValue("update");
        dispatch(setCheckUserAccess(data?.data?.module));
      } else {
        setButtonValue("save");
        dispatch(setCheckUserAccess([]));
      }
    }

    // eslint-disable-next-line
  }, [data, isLoading, isFetching]);

  return (
      <UserAcess
        userRole={userRoleState as string}
        setUserRoleState={setUserRoleState}
        handleUserAccessSubmit={handleUserAccessSubmit}
        apiStatus={apiStatus}
        formType={"Update"}
      />
    
  );
};
export default EditUserAccessWrapper;
